import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Skeleton from 'react-loading-skeleton'
import ConfirmPopup from './../modal/modal';
import ManagementTable from "./../tables/managementTable";
import { boolToYesNo, getUnits, stripHTML, getYesNoOptions, setConfig, getConfig, getYesNo} from "../../utils"
import cloneDeep from 'lodash/cloneDeep';

const ActivitiesAdmin = () => {

    let navigate = useNavigate();
    const { activitiesStore } = useStores();
    const { getAll, activities, remove, duplicate, getAllWithOptions} = activitiesStore;
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);
    

    /*async function fetchMyAPI() {
        setIsLoading(true);
        getAll().then(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        fetchMyAPI();
    }, [getAll]);*/

    const onPageChange = (props) => {        
        var newProps = cloneDeep(props);

        newProps.filterBy?.filters?.forEach(main => {
            main?.filters?.forEach(f => {
                if (["workUnit","billingUnit","salaryUnit"].indexOf(f.field)>-1) {                                        
                    f.value = getUnitOptions()?.find(x => x.text == f.value)?.value;
                }
                
            });
        });
        setIsLoading(true);
        getAllWithOptions(newProps/*props.page + 1, props.filter, props.sort*/).then(() => {
            setIsLoading(false);
        });
    }

    /*const onFilterStoreChange = (props) => {
        setIsLoading(true);
        getAll(page).then(() => {
            setIsLoading(false);
        });
    }*/

    const getUnitOptions = () => {
        return getUnits("fr").map(x => { return { text: x.key, value: x.id?.toString() } });       
    }

    return (
        <span >            
            <ManagementTable name={t('activities')}
                config={{
                    size: getConfig("activities", "size"),
                    dataState: getConfig("activities", "dataState")
                }}
                onColumnSizeChange={(c) => setConfig("activities", "size", c)}
                onDataStateChange={(c) => { setConfig("activities", "dataState", c) }}
                /*onColumnSizeChange={(c) => { setConfig("size", c) }}
                onSortingChange={(c) => { setConfig("sort", c) }}
                onFiltersChange={(c) => { setConfig("filter", c) }}*/
                
                //filters={["code", "startDate", "endDate", "consultant", "project"]}
                ref={tableRef} isLoading={isLoading}
                onDelete={(id) => {
                    remove(id).then(() => { tableRef?.current?.resetPage() })
                }}
                /*onEdit={(id) => {
                    alert(id)
                }}*/
                extraButtons={
                    [
                        { text: t('edit'), icon: solid("pen-to-square"), onClick: (id) => { navigate(`./${id}`) } },
                        { text: t('copy'), icon: solid("copy"), onClick: (id) => { duplicate(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmCopy"), modalTitle: t("copy") },
                        { text: t('delete'), icon: solid("trash"), onClick: (id) => { remove(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmDelete"), modalTitle: t("delete"), danger: true }
                    ]
                }
                items={activities?.results} onPageChange={onPageChange} pageCount={activities?.pageCount} total={activities?.count} pageSize={activities?.pageSize}
                columns={
                    [
                        { name: "code" },
                        { name:"shortStartDate",prop: "startDate", fn: (v) => `${v?.split("-")?.[1]}.${v?.split("-")?.[0]}`, size: 85,type:"month",filter:"date" },
                        { name: "shortEndDate",prop: "endDate", fn: (v) => `${v?.split("-")?.[1]}.${v?.split("-")?.[0]}`, size: 85,type:"month",filter:"date" },

                        {
                            name: "shortConfidential", prop: "confidential", fn: (v) => t(v ? "yes" : "no"), size: 50, filterSelectOptions: getYesNo()
                        },
                        { name:"shortBillable",prop: "billableClient", fn: (v) => t(v ? "yes" : "no"), size: 50, filterSelectOptions: getYesNo() },
                        { name: "salary", fn: (v) => t(v ? "yes" : "no"), size: 50, filterSelectOptions: getYesNo() },

                        { name: "consultant", fn: (v) => `${v?.username}` },
                        { name: "project", fn: (v) => v?.name ?? "-" },

                        { name:"shortWorkUnit",prop: "workUnit", fn: (v) => getUnits().find(x => x.id == v)?.name ?? "-", size: 85, filterSelectOptions: getUnitOptions() },
                        { name:"shortBillingUnit",prop: "billingUnit", fn: (v) => getUnits().find(x => x.id == v)?.name ?? "-", size: 85, filterSelectOptions: getUnitOptions() },
                        { name:"shortAmount",prop: "billingAmount", /*fn: (v) => v ?? "-",*/ size: 85,filter:"numeric",useFormat:true },
                        { name:"shortSalaryUnit",prop: "salaryUnit", fn: (v) => getUnits().find(x => x.id == v)?.name ?? "-", size: 85,  filterSelectOptions: getUnitOptions() },
                        { name: "shortAmount", prop: "salaryAmount", /*fn: (v) => v ?? "-",*/ size: 85, filter: "numeric", useFormat: true },
                    ]
                } /></span>

    );
};

export default observer(ActivitiesAdmin);
